module.exports = __webpack_public_path__ + "img/first_door_coat.30c3e497.webp";